import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-device-data',
    templateUrl: './device-data.component.html',
    standalone: false
})
export class DeviceDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
